import React from 'react'

export default function Download({downloadCanvas}) {
  return (
    <div>
      <div className="mt-4">
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={downloadCanvas}
        >
          Download sketch
        </button>
      </div>
    </div>
  )
}
